import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { Magnetic as Mi } from "../../styles/Semantic";
import { Button, ButtonStyle } from "../button";
const useStyles = makeStyles(theme => ({
    root: {
        flexDirection: 'column',
        flexWrap: 'nowrap',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            '& button': {
                marginBottom: '0'
            }
        }
    },
    progressive: {
        display: 'flex',
        '& button': {
            marginTop: Mi.spacer08
        },
        [theme.breakpoints.up('sm')]: {
            '& button': {
                marginTop: '0',
                marginLeft: Mi.spacer08
            }
        }
    }
}));
/**
 * @param {string} tertiary to display tertiary button with text
 * @param {string} secondary to display secondary button with text
 * @param {string} primary to display primary button with text
 * @param {boolean} isPrimaryButtonDisabled to disable primary button
 * @param {function():void} onTertiaryClick callback triggered when tertiary button is clicked
 * @param {function():void} onSecondaryClick callback triggered when secondary button is clicked
 * @param {function():void} onPrimaryClick callback triggered when primary button is clicked
 * @param {isBusy} isBusy to load the spinner for the Button when the component is Busy
 */
export const AssistanceModalFooter = props => {
    const { tertiary, secondary, primary, isPrimaryButtonDisabled, isBusy, onTertiaryClick, onSecondaryClick, onPrimaryClick } = props;
    const classes = useStyles();
    return (React.createElement(Grid, { container: true, justify: tertiary ? 'space-between' : 'flex-end', className: `regressive ${classes.root}` },
        tertiary && (React.createElement(Button, { id: "assistanceModalTertiaryButton", style: ButtonStyle.Tertiary, onClick: onTertiaryClick, label: tertiary, disabled: isBusy })),
        React.createElement(Grid, { className: `${classes.progressive} ${classes.root}` },
            secondary && (React.createElement(Button, { id: "assistanceModalSecondaryButton", style: ButtonStyle.Secondary, onClick: onSecondaryClick, label: secondary })),
            primary && (React.createElement(Button, { id: "assistanceModalPrimaryButton", style: ButtonStyle.Primary, onClick: onPrimaryClick, label: primary, disabled: isPrimaryButtonDisabled, isBusy: isBusy })))));
};
//# sourceMappingURL=AssistanceModalFooter.js.map